import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import { ROLES } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import AppointmentsIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/appointments'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return {
              name: 'appointments_settings',
              params: to.params,
            };
          },
        },
        {
          path: 'settings',
          name: 'appointments_settings',
          meta: {
            featureFlag: FEATURE_FLAGS.APPOINTMENTS_MODULE,
            permissions: [...ROLES],
          },
          component: AppointmentsIndex,
        },
      ],
    },
  ],
};
